import { render, staticRenderFns } from "./appFormDetail.vue?vue&type=template&id=874e0b5c"
import script from "@/controllers/application_form/app-form-detail.js?vue&type=script&lang=js&external"
export * from "@/controllers/application_form/app-form-detail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports